import { storage } from '@/utils/storage/storage'
import { defineStore } from 'pinia'

export const possibleBackgrounds = ['none', 'test-environment', 'ping'] as const

type Background = (typeof possibleBackgrounds)[number]

type State = {
  blockActions: boolean
  visibleColorModal?: string
}

const getDefaultState = (): State => ({
  blockActions: false,
  visibleColorModal: undefined,
})

export const useUiStore = defineStore('ui', {
  state: getDefaultState,

  getters: {
    isBlockedActions: (state) => state.blockActions,
    background: () => storage.background,
  },

  actions: {
    SET_BLOCK_ACTIONS(value: boolean) {
      this.blockActions = value
    },

    SET_SHOW_COLOR_MODAL(value?: string) {
      this.visibleColorModal = value
    },

    startBlockingActions() {
      this.SET_BLOCK_ACTIONS(true)
    },

    stopBlockingActions() {
      this.SET_BLOCK_ACTIONS(false)
    },

    showColorModal(value?: string) {
      this.SET_SHOW_COLOR_MODAL(value)
    },

    hideColorModal() {
      this.SET_SHOW_COLOR_MODAL()
    },

    setBackground(background: Background) {
      storage.background = background
    },
  },
})
